export default page => `${page} | B & M McHugh Ltd.`;
